import styled from 'styled-components';
/**
 * Picture
 */
export const PictureContainer = styled.picture ``;
